import { useFormContext } from 'react-hook-form'

import { ConfirmDialog } from 'components/common'
import { useUnsavedChangesWarning } from 'hooks'
import { TBookingForm } from 'types'

const BookingDiscardConfirmation = () => {
  const {
    formState: { isDirty, isSubmitSuccessful },
  } = useFormContext<TBookingForm>()

  const { openConfirmDialog, setOpenConfirmDialog, handleConfirmDiscard } =
    useUnsavedChangesWarning({
      isDirty,
      isSubmitSuccessful,
    })

  return (
    <>
      {openConfirmDialog && (
        <ConfirmDialog
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={handleConfirmDiscard}
        />
      )}
    </>
  )
}

export default BookingDiscardConfirmation
